import {Base} from "@/api/Base"

export class ReportBatchAdd extends Base {
    //此处修改后台登录用户修改密码的请求路径
    path = "report/batchAdd"
}